import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/globals.css';
import { Toaster } from './components/ui/toaster';
import { initGA, trackPageView } from './utils/analytics';

// Initialize Google Analytics
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // Replace with your new GA4 ID

// Route tracker component
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA when component mounts
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []); // Run once on mount

  useEffect(() => {
    // Track page views when location changes
    if (location.pathname) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
};

// Lazy load pages
const LandingPage = React.lazy(() => import('./pages/LandingPage'));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'));
const PrivacyPolicyPage = React.lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsPage = React.lazy(() => import('./pages/TermsPage'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const ScalingPlausiblePostPage = React.lazy(() => import('./pages/ScalingPlausiblePostPage'));
const OngoingSupportPage = React.lazy(() => import('./pages/OngoingSupportPage'));
const BootstrappedPage = React.lazy(() => import('./pages/BootstrappedPage'));

function App() {
  return (
    <Router>
      <RouteTracker />
      <React.Suspense
        fallback={
          <div className="flex h-screen items-center justify-center">
            <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-gray-900"></div>
          </div>
        }
      >
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/ongoing-support" element={<OngoingSupportPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route
            path="/blog/scaling-plausible-analytics-1-4-for-millions-of-sites"
            element={<ScalingPlausiblePostPage />}
          />
          <Route path="/bootstrapped" element={<BootstrappedPage />} />
          
          {/* Fallback routes */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </React.Suspense>
      <Toaster />
    </Router>
  );
}

export default App;
